import { render } from "./App.vue?vue&type=template&id=bb08853a"
const script = {}

import exportComponent from "/var/www/briskly/brskl/products/business/app.prod.new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__